import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast } from 'services/toasterService';

export default function useDeleteSpecificTaskMember() {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.delete(apiEndPoints.TASK_MEMBERS, {
        data: data,
      });
      return response?.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('get-all-buckets');
        queryClient.invalidateQueries('get-specific_task_members');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
